/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationRuleDto } from './notificationRuleDto';
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';
import { ShareDto } from './shareDto';
import { ParameterData } from './parameterData';
import { RequestedShare } from './requestedShare';


export interface TrapExtendedDto { 
    id?: number;
    label?: string;
    role?: TrapExtendedDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    deviceTypeId?: string;
    deviceTypeCustomerName?: string;
    deviceTypeActivityChannelOrientations?: ActivityChannelOrientationConfiguration;
    parameterDataList?: Array<ParameterData>;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    updateTs?: string;
    pcbTypeId?: string;
    nfcTagUid?: string;
    comType?: TrapExtendedDto.ComTypeEnum;
    comId?: string;
    blacklisted?: boolean;
    lastReception?: string;
    lastReceptionDataEventType?: TrapExtendedDto.LastReceptionDataEventTypeEnum;
    notifications?: Array<NotificationRuleDto>;
    beaconFrequency?: number;
    networkStatus?: TrapExtendedDto.NetworkStatusEnum;
    dataPlan?: TrapExtendedDto.DataPlanEnum;
    airtimeOwnerNames?: Array<string>;
    airtimeOwnerEmails?: Array<string>;
    airtimeNetworkStatusChangeRequested?: TrapExtendedDto.AirtimeNetworkStatusChangeRequestedEnum;
    trapEventCount?: number;
    lastEventTriggered?: boolean;
}
export namespace TrapExtendedDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const LastReceptionDataEventTypeEnum = {
        Unknown: 'UNKNOWN',
        GpsPosition: 'GPS_POSITION',
        Separation: 'SEPARATION',
        TrapEvent: 'TRAP_EVENT',
        Proximity: 'PROXIMITY',
        Mortality: 'MORTALITY',
        MortalityImplant: 'MORTALITY_IMPLANT',
        VaginalImplant: 'VAGINAL_IMPLANT',
        Activity: 'ACTIVITY',
        GsmQuality: 'GSM_QUALITY',
        VirtualFence: 'VIRTUAL_FENCE',
        CollarLog: 'COLLAR_LOG'
    } as const;
    export type LastReceptionDataEventTypeEnum = typeof LastReceptionDataEventTypeEnum[keyof typeof LastReceptionDataEventTypeEnum];
    export const NetworkStatusEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusEnum = typeof NetworkStatusEnum[keyof typeof NetworkStatusEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
}


